/**
 * Creates the redux store.
 */

import createSagaMiddleware from 'redux-saga';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import formActionSaga from 'redux-form-saga';
import { bannerMiddleware } from 'features/Banners/Banners.middleware';
import { decorateStore } from './decorateStore';

export default function createStore(historyInstance, data, { onError }) {
  const middleware = [];

  if (historyInstance) {
    middleware.push(routerMiddleware(historyInstance));
  }

  middleware.push(bannerMiddleware());

  // Store is declared here so that the `createSagaMiddleware` has access to the store later on after it's created
  // due to decorators having to be declared in order to create the store.
  let store;

  const sagaMiddleware = createSagaMiddleware({
    onError: (error, { sagaStack }) => onError(error, { sagaStack, store }),
  });
  middleware.push(sagaMiddleware);

  let finalCreateStore;
  if (__LOCAL_DEV__ && __CLIENT__) {
    /* eslint-disable no-underscore-dangle */
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    finalCreateStore = composeEnhancers(applyMiddleware(...middleware))(_createStore);
    /* eslint-enable */
  } else {
    finalCreateStore = applyMiddleware(...middleware)(_createStore);
  }

  const reducer = require('./modules/reducer').default;

  const baseStore = finalCreateStore(reducer, data || {});
  store = decorateStore(baseStore, sagaMiddleware);

  let history;
  if (historyInstance) {
    history = syncHistoryWithStore(historyInstance, store);
  }

  if (__LOCAL_DEV__ && module.hot) {
    module.hot.accept('./modules/reducer', () => {
      store.replaceReducer(require('./modules/reducer').default);
    });
  }

  sagaMiddleware.run(formActionSaga);

  return { store, history };
}
